import { propStyles } from 'src/utils/propStyles';
import { styled } from 'src/utils/styled';

const ClearIndividualFiltersButton = styled<any, any>(
    'button',
    'clearIndividualFiltersButton',
    'filterItemDropdown'
)`
    ${propStyles};
`;

ClearIndividualFiltersButton.defaultProps = {
    display: 'flex',
    fontFamily: 'body',
    fontWeight: 'normal',
    fontSize: 'sm',
    color: 'gray500',
    bgColor: 'transparent',
    borderStyle: 'none',
    cursor: 'pointer',
    outline: 'none',
    selected: {
        color: 'body',
    },
};

export default ClearIndividualFiltersButton;



// WEBPACK FOOTER //
// ./src/Components/Filters/Components/StyledComponents/ClearIndividualFiltersButton.tsx